
  import {Component, Vue} from 'vue-property-decorator';
  import {getMapFloorByPointIdAsync} from '@/api/floor';

  import {getMapPointById} from '@/api/map';

  @Component({})
  export default class FloorIndex extends Vue {
    private baseUrl = Vue.prototype.$appsettings.serverUrl + '/';
    private floor = {
      mapUrl: '',
      name: '',
      id: undefined
    };

    private floors: any[] = [];
    private floorStr = '';

    private get roomId() {
      return this.$route.query.roomId;
    }

    private async mounted() {
      if (this.roomId) {
        await this.getFloor();
      }
    }

    private async getFloor() {
      let point = await getMapPointById(this.roomId.toString());
      if (point.isInRoom) {
        let result = await getMapFloorByPointIdAsync(this.roomId);
        if (result.items.length > 0) {
          this.floors = result.items;
          const maps = result.items.filter((x: any) => {
            return x.mapUrl;
          });

          if (maps.length > 0) {
            if (maps[0].mapUrl) {
              this.floor.mapUrl = `${this.baseUrl}${maps[0].mapUrl}`;
            }
          }

          this.floor.name = point.name;
          if (result.items.length === 1 && maps.length === 1) {
            this.floor.name = maps[0].name;
            this.floor.id = maps[0].id;
          } else if (result.items.length > 1) {
            let first = result.items[0].name;
            let last = result.items[result.items.length - 1].name;
            this.floorStr = `${last}-${first}`;
          }
        }
      }
    }

    private handleClick(id: string, mapUrl: string) {
      if (id && mapUrl) {
        this.$router.push({
          path: '/floor/map',
          query: {
            roomId: id
          }
        });
      }
    }

    private handleBack() {
      this.$router.push('/');
    }
  };
